// GstRegistrationPage.js

import React from "react";
import "../components/Styles/GstRegistrationPage.css";

function GstRegistrationPage() {

  return (

    <div className="gst-page">

      {/* HERO SECTION */}

      <section className="gst-hero-section">

        <div className="gst-hero-overlay"></div>

        <div className="container">

          <div className="gst-hero-badge">
            GST Registration Portal
          </div>

          <h1 className="gst-hero-heading">
            Register Your <span>GST</span> Easily
          </h1>

          <p className="gst-hero-text">
            Get your GST registration completed quickly with expert
            assistance, fast approval process, and secure
            documentation support for your business.
          </p>

          <div className="gst-hero-search-box">

            <input
              type="text"
              placeholder="Enter Business Name"
            />

            <button>
              Start Registration
            </button>

          </div>

          <div className="gst-hero-features">

            <div className="gst-feature-card">

              <h3>2 Days Process</h3>

              <p>
                Quick GST filing & registration support.
              </p>

            </div>

            <div className="gst-feature-card">

              <h3>100% Online</h3>

              <p>
                Complete registration from your home.
              </p>

            </div>

            <div className="gst-feature-card">

              <h3>Expert Support</h3>

              <p>
                CA & GST professionals available 24/7.
              </p>

            </div>

          </div>

        </div>

      </section>

      {/* GST PROCESS SECTION */}

      <section className="gst-process-section">

        <div className="container">

          <div className="gst-process-wrapper">

            {/* LEFT SIDE */}

            <div className="gst-process-left">

              {/* TOP INFO */}

              <div className="gst-process-top">

                <div className="gst-rating-box">

                  <h1>4.6</h1>

                  <div className="gst-stars">
                    ★ ★ ★ ★ ☆
                  </div>

                  <p>(2345 reviews)</p>

                </div>

                <div className="gst-process-content">

                  <h2>GST REGISTRATION</h2>

                  <p>
                    Now get your GST registration done quickly
                    with experienced professionals.
                  </p>

                  <div className="gst-users-count">

                    <span>👤</span>

                    <h3>
                      76894 <small>People purchased</small>
                    </h3>

                  </div>

                </div>

              </div>

              {/* HOW IT WORKS */}

              <div className="gst-how-section">

                <h2>How It Works</h2>

                <div className="gst-how-grid">

                  <div className="gst-how-card">

                    <div className="gst-how-icon gst-blue">
                      📄
                    </div>

                    <h3>
                      Choose your required Product & Pay
                    </h3>

                    <p>
                      Choose any product or combine two to get more discount
                    </p>

                  </div>

                  <div className="gst-how-card">

                    <div className="gst-how-icon gst-pink">
                      ✍️
                    </div>

                    <h3>
                      Fill required details
                    </h3>

                    <p>
                      Fill your details and upload the required documents
                    </p>

                  </div>

                  <div className="gst-how-card">

                    <div className="gst-how-icon gst-green">
                      💬
                    </div>

                    <h3>
                      Receive updates
                    </h3>

                    <p>
                      Receive updates on WhatsApp & SMS regularly
                    </p>

                  </div>

                  <div className="gst-how-card">

                    <div className="gst-how-icon gst-purple">
                      📦
                    </div>

                    <h3>
                      Delivery of your product
                    </h3>

                    <p>
                      Get final registration delivered quickly
                    </p>

                  </div>

                </div>

              </div>

              {/* GST INFO */}

              <div className="gst-info-section">

                <div className="gst-content-box">

                  <h2>
                    What is GST (Goods and Service Tax)?
                  </h2>

                  <p>
                    GST stands for Goods and Services Tax. It's a tax in India that
                    replaced several older taxes like excise duty and service tax.
                  </p>

                  <p>
                    GST was implemented on 1st July 2017 and applies throughout India.
                  </p>

                  <p>
                    GST registration is important for business compliance and credibility.
                  </p>

                </div>

                <div className="gst-content-box">

                  <h2>
                    Should you register for GST?
                  </h2>

                  <ul>

                    <li>Casual taxable persons</li>

                    <li>Non-resident casual taxable persons</li>

                    <li>Persons making inter-state taxable supplies</li>

                    <li>E-commerce operators</li>

                    <li>TDS/TCS deductors</li>

                    <li>Import-export businesses</li>

                    <li>Amazon & Flipkart sellers</li>

                  </ul>

                </div>

                <div className="gst-content-box">

                  <h2>
                    Documents needed for GST Registration
                  </h2>

                  <ul>

                    <li>PAN Card</li>

                    <li>Proof of Business Registration</li>

                    <li>Proof of Identity</li>

                    <li>Photographs</li>

                    <li>Business Bank Account</li>

                    <li>Business Address Proof</li>

                  </ul>

                </div>

                <div className="gst-content-box">

                  <h2>
                    When is it Mandatory for GST Registration?
                  </h2>

                  <ul>

                    <li>
                      Manufacturing sector: Rs. 40 lacs or higher
                    </li>

                    <li>
                      Service sector: Rs. 20 lacs or higher
                    </li>

                    <li>
                      Special category states: Rs. 10 lacs or more
                    </li>

                  </ul>

                </div>

              </div>

            </div>

            {/* RIGHT SIDE STICKY FORM */}

            <div className="gst-process-right">

              <div className="gst-main-sticky-form">

                <h2>
                  Registrations & Licenses
                </h2>

                <div className="gst-product-row">

                  <div>

                    <h3>GST Registration</h3>

                    <span>(48% Off)</span>

                  </div>

                  <div className="gst-price-box">

                    <h4>₹3499</h4>

                    <p>₹7999</p>

                  </div>

                </div>

                <div className="gst-extra-row">

                  <input type="checkbox" />

                  <label>
                    Annual GST Return Filing
                  </label>

                </div>

                <div className="gst-total-box">

                  <h3>Gross Total</h3>

                  <h2>₹3499</h2>

                </div>

                <div className="gst-deliver-box">

                  <h4>Deliverables *</h4>

                  <p>
                    GST Registration process end to end.
                  </p>

                </div>

                <div className="gst-payment-icons">

                  <span>VISA</span>
                  <span>GPay</span>
                  <span>Paytm</span>
                  <span>PhonePe</span>

                </div>

                <button className="gst-register-btn">
                  REGISTER NOW
                </button>

              </div>

            </div>

          </div>

        </div>

      </section>

      {/* =========================
    GST BENEFITS SECTION
========================= */}

<section className="gst-benefits-section">

  <div className="container">

    <div className="gst-benefits-heading">

      <span className="gst-benefits-tag">
        Why Choose Us
      </span>

      <h2>
        Benefits of GST Registration
      </h2>

      <p>
        GST registration helps your business become legally compliant,
        trusted, and growth-ready with nationwide tax benefits.
      </p>

    </div>

    <div className="gst-benefits-grid">

      {/* CARD 1 */}

      <div className="gst-benefit-card">

        <div className="gst-benefit-icon gst-benefit-orange">
          📈
        </div>

        <h3>
          Business Expansion
        </h3>

        <p>
          Sell products and services across India without tax barriers.
        </p>

      </div>

      {/* CARD 2 */}

      <div className="gst-benefit-card">

        <div className="gst-benefit-icon gst-benefit-blue">
          🛡️
        </div>

        <h3>
          Legal Compliance
        </h3>

        <p>
          Stay compliant with government tax rules and avoid penalties.
        </p>

      </div>

      {/* CARD 3 */}

      <div className="gst-benefit-card">

        <div className="gst-benefit-icon gst-benefit-green">
          💰
        </div>

        <h3>
          Input Tax Credit
        </h3>

        <p>
          Claim tax credits on purchases and reduce your tax burden.
        </p>

      </div>

      {/* CARD 4 */}

      <div className="gst-benefit-card">

        <div className="gst-benefit-icon gst-benefit-purple">
          🤝
        </div>

        <h3>
          Better Business Trust
        </h3>

        <p>
          Increase credibility and build trust with customers & vendors.
        </p>

      </div>

      {/* CARD 5 */}

      <div className="gst-benefit-card">

        <div className="gst-benefit-icon gst-benefit-pink">
          🌐
        </div>

        <h3>
          E-commerce Selling
        </h3>

        <p>
          Mandatory for selling on Amazon, Flipkart & online platforms.
        </p>

      </div>

      {/* CARD 6 */}

      <div className="gst-benefit-card">

        <div className="gst-benefit-icon gst-benefit-yellow">
          ⚡
        </div>

        <h3>
          Faster Loan Approval
        </h3>

        <p>
          GST registration improves business authenticity for banks.
        </p>

      </div>

    </div>

  </div>

</section>

{/* =========================
    OUR CLIENTS SECTION
========================= */}

<section className="gst-clients-section">

  <div className="container">

    <div className="gst-clients-top">

      <span className="gst-client-tag">
        Trusted By Businesses
      </span>

      <h2>
        Our Happy Clients
      </h2>

      <p>
        Thousands of startups, agencies, freelancers and companies
        trust us for GST registration & compliance services.
      </p>

    </div>

    {/* LOGO SLIDER */}

    <div className="gst-client-slider">

      <div className="gst-client-track">

        {/* ROW 1 */}

        <div className="gst-client-logo">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg"
            alt="amazon"
          />
        </div>

        <div className="gst-client-logo">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/2/24/Samsung_Logo.svg"
            alt="samsung"
          />
        </div>

        <div className="gst-client-logo">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg"
            alt="apple"
          />
        </div>

        <div className="gst-client-logo">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
            alt="microsoft"
          />
        </div>

        <div className="gst-client-logo">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/5/51/IBM_logo.svg"
            alt="ibm"
          />
        </div>

        <div className="gst-client-logo">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/0/08/Netflix_2015_logo.svg"
            alt="netflix"
          />
        </div>

        {/* SAME LOGOS AGAIN FOR SMOOTH LOOP */}

        <div className="gst-client-logo">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg"
            alt="amazon"
          />
        </div>

        <div className="gst-client-logo">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/2/24/Samsung_Logo.svg"
            alt="samsung"
          />
        </div>

        <div className="gst-client-logo">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg"
            alt="apple"
          />
        </div>

        <div className="gst-client-logo">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
            alt="microsoft"
          />
        </div>

        <div className="gst-client-logo">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/5/51/IBM_logo.svg"
            alt="ibm"
          />
        </div>

        <div className="gst-client-logo">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/0/08/Netflix_2015_logo.svg"
            alt="netflix"
          />
        </div>

      </div>

    </div>

  </div>

</section>

    </div>

  );

}

export default GstRegistrationPage;